import React from "react";

import { bem, getMilliseconds } from "../../utils";
import { SupervisorBadge, Countdown } from "../../components";
import { supervisorsData, START_TIMESTAMP_MS } from "./constants";
import "./Year.scss";

const classNames = bem("year");

export const Year = () => (
    <div className={classNames()}>
        <h1>Letos</h1>
        <div className={classNames("panel")}>
            <h2>Základní informace</h2>
            <div className={classNames("row")}>
                <div className={classNames("left-part")}>
                    Téma<br />
                    Datum konání
                </div>
                <div>
                    Rychlé šípy<br />
                    19.–26. 7. 2026
                </div>
            </div>
        </div>
        <div className={classNames("panel")} style={{ textAlign: "justify" }}>
            <p>
                Vydejte se s námi na dobrodružství s legendárním klubem Rychlých šípů – partě kamarádů, v níž každý nese jinou povahu,
                ale všichni sdílejí smysl pro čest a tiché hrdinství. Vůdcovství, bystrý úsudek, spolehlivost, tvořivost i rozpustilý
                humor se spojují v obraz ideálního kamarádství, které obstojí v každé době.
            </p>
            <p>
                Budeme pátrat po odkazu Jana Tleskače, vypravíme se do Stínadel a pokusíme se přijít na tajemství Ježka v kleci.
                Ale pozor! Bratrstvo kočičí pracky číhá poblíž. Podaří se nám být rychlejší a chytřejší? To už zjistíme společně.
            </p>
        </div>
        {START_TIMESTAMP_MS > getMilliseconds() ? (
            <div className={classNames("panel")}>
                <div className={classNames("row")}>
                    <span className={classNames("countdown-description")}>Začínáme za</span>
                    <Countdown countdownTimestamp={START_TIMESTAMP_MS} />
                </div>
            </div>
        ) : null}
        <div className={classNames("panel")}>
            <h2>Stav přihlášek</h2>
            <div className={classNames("row")}>
                Kapacita turnusu naplněna
            </div>
        </div>
        <div className={classNames("panel")}>
            <h2>Vedoucí</h2>
            {supervisorsData.map((supervisor) => (
                <SupervisorBadge
                    key={supervisor.id}
                    {...supervisor}
                />
            ))}
        </div>
    </div>
);
